$(document).ready(function(){
  $('.load_action').addClass('active');
});



$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }
    });
    $('.section_wrapper').each(function(){
      var secPos = $(this).offset().top;
      var num = $(this).data('n');
      var firstPos = $('#keyboard').offset().top;
      if (scroll < firstPos - (windowHeight / 2.5)) {
        $('.side_menu li').removeClass('active');
      }
      if (scroll > secPos - (windowHeight / 2.5)) {
        $('.side_menu li').removeClass('active');
        $('.side_menu li:nth-child('+num+')').addClass('active');
      }
    });
  });

  $('.sp_menu_btn').click(function(){
    $('.wrapper').toggleClass('menu_open');
  });
  $('.sp_menu_container a').click(function(){
    $('.wrapper').removeClass('menu_open');
  });


});
